// const API_PATH = 'http://localhost:3000/api'
const API_PATH = 'https://mmlatticework.jayliew.com:7001/api'

export default API_PATH
